/* unplugin-vue-components disabled */import { render } from "./BaseLayout.vue?vue&type=template&id=2686ad31&ts=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=2686ad31&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__